<template>
    <div class="header"  :style="{'background-color': themeColor}">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i class="el-icon-menu"></i>
        </div>
        <div class="logo">国泰安基础平台</div>

        <div class="header-right">
            <div class="header-user-con">
                <!-- 主题切换 -->
                <div style="width: 60px">
                    <theme-picker class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
                </div>
                <!-- 全屏显示 -->
                <div class="btn-fullscreen" @click="handleFullScreen">
                    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
                        <i class="el-icon-rank"></i>
                    </el-tooltip>
                </div>
                <!-- 消息中心 -->
                <!-- <div class="btn-bell">
                  <el-tooltip effect="dark" :content="message?`有${message}条未读消息`:`消息中心`" placement="bottom">
                    <router-link to="/tabs">
                      <i class="el-icon-bell"></i>
                    </router-link>
                  </el-tooltip>
                  <span class="btn-bell-badge" v-if="message"></span>
                </div> -->
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img v-if="imgUrl" :src="imgUrl" alt/>
                    <img v-else src="../../../assets/img/logo-default-img.jpg" alt/>
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{name}}
            <i class="el-icon-caret-bottom"></i>
          </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
    import bus from "./bus";
    import ThemePicker from "@/common/components/ThemePicker"
    import config from '@/config'
    import loginApi from '@/resources/login/login'
    import {mapGetters, mapMutations } from 'vuex'
    export default {
        components:{
            ThemePicker,
        },
        data() {
            return {
                imgUrl: "",
                collapse: false,
                fullscreen: false,
                message: 0,
                name: ''
            };
        },
        created() {
            if (this.$store.state.userInfo) {
                this.imgUrl = this.$store.state.userInfo.imgUrl;
                this.name = this.$store.state.userInfo.realName
            } else if (sessionStorage.userInfo && sessionStorage.userInfo !== 'undefind') {
                let userInfo = JSON.parse(sessionStorage.userInfo)
                this.imgUrl = userInfo.imgUrl;
                this.name = userInfo.realName
            }

            console.log("themeColor", this.themeColor)
        },
        methods: {
            // 切换主题
            onThemeChange: function (themeColor) {
                this.setThemeColor(themeColor);
            },
            // 用户名下拉菜单选择事件
            handleCommand(command) {
                if (command == "loginout") {
                    //this.$router.push("/login");
                    let data = {token: ""};
                    if (this.$store.state.token) {
                    data = {token: this.$store.state.token};
                    } else if (
                    sessionStorage.token &&
                    sessionStorage.token !== "undefind"
                    ) {
                    data = {token: sessionStorage.token};
                    }

                    loginApi.loginOut(data).then(res => {
                        this.$router.push("/login");
                        this.$store.commit("LOGOUT");
                     });
                                    
                }
            },
            // 侧边栏折叠
            collapseChage() {
                this.collapse = !this.collapse;
                bus.$emit("collapse", this.collapse);
            },
            // 全屏事件
            handleFullScreen() {
                let element = document.documentElement;
                if (this.fullscreen) {
                    if (document.exitFullscreen) {
                        document.exitFullscreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                } else {
                    if (element.requestFullscreen) {
                        element.requestFullscreen();
                    } else if (element.webkitRequestFullScreen) {
                        element.webkitRequestFullScreen();
                    } else if (element.mozRequestFullScreen) {
                        element.mozRequestFullScreen();
                    } else if (element.msRequestFullscreen) {
                        // IE11
                        element.msRequestFullscreen();
                    }
                }
                this.fullscreen = !this.fullscreen;
            },
            ...mapMutations({
                setThemeColor: 'app/setThemeColor',
            }),
        },
        mounted() {
            if (document.body.clientWidth < 1500) {
                this.collapseChage();
            }
        },
        computed:{
            ...mapGetters({
                themeColor: 'app/themeColor'
            }),
        }
    };
</script>
<style scoped>
    @import '../../../assets/css/layout/header.css';
</style>
